import { ConversationTranscriptionEndedEntry } from 'lib-shared-legacy-types';

import { LogEntry } from './logEntry';

type ConversationTranscriptionEndedProps = {
  entry: ConversationTranscriptionEndedEntry;
};

export const ConversationTranscriptionEnded = ({
  entry,
}: ConversationTranscriptionEndedProps): JSX.Element => {
  const text = entry.is_successful ? (
    <>Conversation transcription ended successfully</>
  ) : (
    <>Error while transcribing the conversation</>
  );
  return (
    <LogEntry entry={entry} text={text} secondaryText={entry.failure_reason} />
  );
};
